var exports = {
  "kL": "PersonaSettingsTab.module__container___UVRKOS",
  "hL": "PersonaSettingsTab.module__cardList___UVRKOS",
  "RO": "PersonaSettingsTab.module__activeCard___UVRKOS",
  "RN": "PersonaSettingsTab.module__cardDetails___UVRKOS",
  "Z_": "PersonaSettingsTab.module__cardPrimaryRow___UVRKOS",
  "_O": "PersonaSettingsTab.module__cardName___UVRKOS",
  "jK": "PersonaSettingsTab.module__cardPronouns___UVRKOS",
  "$1": "PersonaSettingsTab.module__cardSecondaryRow___UVRKOS",
  "uU": "PersonaSettingsTab.module__tagPill___UVRKOS",
  "rY": "PersonaSettingsTab.module__cardBio___UVRKOS",
  "eB": "PersonaSettingsTab.module__cardActions___UVRKOS",
  "zw": "PersonaSettingsTab.module__formLabel___UVRKOS",
  "_Z": "PersonaSettingsTab.module__textInput___UVRKOS",
  "sl": "PersonaSettingsTab.module__colorPreview___UVRKOS",
  "p$": "PersonaSettingsTab.module__emptyState___UVRKOS",
  "GW": "PersonaSettingsTab.module__visibilityIcon___UVRKOS",
  "F2": "PersonaSettingsTab.module__iconPublic___UVRKOS",
  "H4": "PersonaSettingsTab.module__iconPrivate___UVRKOS",
  "l3": "PersonaSettingsTab.module__displayTagControlWrapper___UVRKOS",
  "E_": "PersonaSettingsTab.module__displayTagInputs___UVRKOS",
  "IH": "PersonaSettingsTab.module__displayTagTextField___UVRKOS",
  "oE": "PersonaSettingsTab.module__displayTagIconField___UVRKOS",
  "Kj": "PersonaSettingsTab.module__tagIconRow___UVRKOS",
  "Nn": "PersonaSettingsTab.module__tagIconImage___UVRKOS",
  "i1": "PersonaSettingsTab.module__previewContainer___UVRKOS",
  "Pg": "PersonaSettingsTab.module__previewLabel___UVRKOS",
  "B0": "PersonaSettingsTab.module__previewCard___UVRKOS",
  "MM": "PersonaSettingsTab.module__previewAvatar___UVRKOS",
  "dd": "PersonaSettingsTab.module__previewMessageContent___UVRKOS",
  "yl": "PersonaSettingsTab.module__previewHeader___UVRKOS",
  "gz": "PersonaSettingsTab.module__previewName___UVRKOS",
  "JI": "PersonaSettingsTab.module__previewTimestamp___UVRKOS",
  "Rd": "PersonaSettingsTab.module__previewBody___UVRKOS",
  "HO": "PersonaSettingsTab.module__listControls___UVRKOS",
  "Rt": "PersonaSettingsTab.module__searchInput___UVRKOS",
  "qc": "PersonaSettingsTab.module__searchIcon___UVRKOS",
  "a5": "PersonaSettingsTab.module__clearSearchButton___UVRKOS",
  "CK": "PersonaSettingsTab.module__compactPersonaCard___UVRKOS",
  "E1": "PersonaSettingsTab.module__chevronButton___UVRKOS",
};

module.exports = exports;
